// Constants for security roles
// NOTES: Please keep sorted alphabetically
// and keep in sync with IGS.Solar.Core\Constants\SolarOpsRoles.cs
export class RoleList {
  public readonly approveBatches = "Approve Batch";
  public readonly approveEpcInvoices = "Approve EPC Invoices";
  public readonly approveScheduleA1 = "Approve Schedule A-1";
  public readonly associateUtilityRegion = "Associate Utility Region";
  public readonly administrateDocusign = "Administrate Docusign";
  public readonly assignSalesRep = "Assign Sales Rep";
  public readonly bypassPayment = "Bypass Payment";
  public readonly captureResidentialPayment = "Capture Residential Payment";
  public readonly changePasswordForUser = "Change Password For User";
  public readonly collectPaymentInformation = "Collect Payment Information";
  public readonly captureCommercialCustomer = "Capture Commercial Customer";
  public readonly captureCommunityPayment = "Capture Community Payment";
  public readonly createCustomer = "Create Customer";
  public readonly editCustomerAdminDetails = "Edit Customer Admin Details";
  public readonly editCustomerDetails = "Edit Customer Details";
  public readonly editCustomerIncentives = "Edit Customer Incentives";
  public readonly editExtendedCustomerDetails = "Edit Extended Customer Details";
  public readonly editInactiveCustomerNumber = "Edit Inactive Customer Number";
  public readonly editSystemReviews = "Edit System Reviews";
  public readonly financeApproveBatches = "Finance Approve Batch";
  public readonly manageAllPartnersIssues = "Manage All Partners Issues";
  public readonly manageAllIssues = "Manage All Issues";
  public readonly manageCommercialInvoices = "Manage Commercial Invoices";
  public readonly manageComponents = "Manage Components";
  public readonly manageCustomerDocuments = "Manage Customer Documents";
  public readonly managerCustomerNotices = "Manage Customer Notices";
  public readonly manageEpcAssumedValues = "Manage EPC Assumptions";
  public readonly manageGeneralBanners = "Manage General Banners";
  public readonly manageInventory = "Manage Inventory";
  public readonly manageLeadAgentCode = "Manage Lead Agent Code";
  public readonly manageMyIssues = "Manage My Issues";
  public readonly manageMyTeamsIssues = "Manage My Teams Issues";
  public readonly manageProperties: "Manage Properties";
  public readonly manageReferenceValues = "Manage Reference Values";
  public readonly manageResidentialInvoices = "Manage Residential Invoices";
  public readonly manageSystemDetails = "Manage System Details";
  public readonly manageUsers = "Manage Users";
  public readonly manageUsersAdmin = "Manage Users Admin";
  public readonly modifyVerifiedPhoneNumber = "Modify Verified Phone Number";
  public readonly noRoleForState = "NoRoleForState";
  public readonly overridePricing = "Override Pricing";
  public readonly performCreditCheck = "Perform Credit Check";
  public readonly reconcileEpc = "Reconcile EPC";
  public readonly removePto = "Remove PTO";
  public readonly searchCustomers = "Search Customers";
  public readonly sendContract = "Send Contract";
  public readonly sendPasswordReset = "Send Password Reset";
  public readonly sendRemoteCreditAuth = "Send Remote Credit Auth";
  public readonly sendRemoteElectronicConsent = "Send Remote Electronic Consent";
  public readonly submitEpcInvoices = "Submit EPC Invoices";
  public readonly submitScheduleA1 = "Submit Schedule A-1";
  public readonly submitSystemDetails = "Submit System Details";
  public readonly transferContract = "Transfer Contract";
  public readonly updatePaymentMethod = "Update Payment Method";
  public readonly useEpcCalculator = "Use EPC Calculator";
  public readonly viewAllCustomers = "View All Customers";
  public readonly viewAllPricing = "View All Pricing";
  public readonly viewCustomerDetails = "View Customer Details";
  public readonly viewCustomerInvoices = "View Customer Invoices";
  public readonly viewCustomerTransactions = "View Customer Transactions";
  public readonly viewEpcCostsAndTotals = "View EPC Costs and Totals";
  public readonly viewProduction = "View Production";
  public readonly viewProductionPortal = "View Production Portal";
  public readonly viewSalesforceAccount = "View Salesforce Account";
}
